module.exports = __webpack_public_path__ + "static/media/image_287.5c0da9e3.png";